import algoliasearch from 'algoliasearch/lite';
import { createInstantSearch } from 'react-instantsearch-core';

var InstantSearch = createInstantSearch(algoliasearch, {
  Root: 'div',
  props: {
    className: 'ais-InstantSearch__root'
  }
});

export default InstantSearch;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-instantsearch-dom/dist/es/widgets/InstantSearch.js
// module id = 754
// module chunks = 0